import { render, staticRenderFns } from "./InformationSecurityJournalView.vue?vue&type=template&id=6859f1f8&scoped=true&"
import script from "./InformationSecurityJournalView.vue?vue&type=script&lang=ts&"
export * from "./InformationSecurityJournalView.vue?vue&type=script&lang=ts&"
import style0 from "./InformationSecurityJournalView.vue?vue&type=style&index=0&id=6859f1f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6859f1f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
